/**
 * 会员权益
 */
import { VIP_EQUITY } from '../types';

export default {
    name: `${VIP_EQUITY}`,
    path: '/VipEquity',
    component: () => import(/* webpackChunkName: 'vipEquity' */ '@/views/vipEquity/'),
    redirect: { name: `${VIP_EQUITY}Index` },
    meta: {
        title: '会员权益',
        // 页签缓存的滚动条位置
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${VIP_EQUITY}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'vipEquity' */ '@/views/vipEquity/home/Home.vue'),
        },
        {
            name: `${VIP_EQUITY}Update`,
            path: 'update',
            component: () => import(/* webpackChunkName: 'vipEquity' */ '@/views/vipEquity/create/Create.vue'),
        },
    ],
};
